/**
 * Search on the merchant list. `merchants.search_text` holds lowercased business name, owner name,
 * email and the E.164 phone; the browser filters it with ILIKE (trigram index in the M3 migration).
 */

/** Something that looks like part of a phone number: "(555) 12", "555-1234", "+1 555". */
const PHONE_LIKE = /^[\d\s().+-]+$/;

/**
 * The ILIKE pattern for a search box entry, or null when there is nothing to search for.
 * Phone-like input is reduced to its digits so "(555) 123" finds "+15551234567".
 * `%`, `_` and `\` are escaped so they match literally.
 */
export function merchantSearchPattern(term: string): string | null {
  const t = term.trim().toLowerCase().slice(0, 100);
  if (t === '') return null;
  const digits = t.replace(/\D/g, '');
  const needle = PHONE_LIKE.test(t) && digits.length >= 3 ? digits : t;
  return `%${needle.replace(/[\\%_]/g, (c) => `\\${c}`)}%`;
}
